import {useMyProfile} from './useMyProfile';

export const useIndicatorOptions = () => {
  const {data, isLoading} = useMyProfile();
  const indicators = Object.keys(data?.user?.user_options?.indicators || {});
  const indicatorOptions = data?.user?.user_options?.indicators || {};

  return {indicators, indicatorOptions, isLoading};
};
